import React from 'react'
import { CustomPopUpWithPortalPropsType } from '../../utils'
import { createPortal } from 'react-dom'

const CustomPopUpWithPortal = ({
  children,
  position,
  containerId,
}: CustomPopUpWithPortalPropsType) => {
  const container = document.getElementById(containerId)

  return container
    ? createPortal(
        <div
          className="absolute z-[99]"
          style={{
            top: position?.top ?? 'none',
            left: position?.left ?? 'none',
            right: position?.right ?? 'none',
            bottom: position?.bottom ?? 'none',
            ...(position?.width && { width: position?.width }),
          }}
        >
          {children}
        </div>,
        container
      )
    : null
}

export default CustomPopUpWithPortal
